(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var container = document.querySelector('[data-cart-page-items]');
    var cartPage = document.querySelector('.cart-page');
    if (!container) return;

    // Mirrors Liquid's `money` filter so updated prices match the initial render.
    function formatMoney(cents) {
      var format = cartPage.dataset.moneyFormat;

      function withSeparators(decimals, thousands, decimal) {
        var fixed = (cents / 100).toFixed(decimals).split('.');
        var whole = fixed[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return fixed[1] ? whole + decimal + fixed[1] : whole;
      }

      if (format) {
        var matched = false;
        var result = format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, name) {
          switch (name) {
            case 'amount': matched = true; return withSeparators(2, ',', '.');
            case 'amount_no_decimals': matched = true; return withSeparators(0, ',', '.');
            case 'amount_with_comma_separator': matched = true; return withSeparators(2, '.', ',');
            case 'amount_no_decimals_with_comma_separator': matched = true; return withSeparators(0, '.', ',');
            case 'amount_with_apostrophe_separator': matched = true; return withSeparators(2, '\'', '.');
            case 'amount_no_decimals_with_space_separator': matched = true; return withSeparators(0, ' ', '.');
            case 'amount_with_space_separator': matched = true; return withSeparators(2, ' ', ',');
            case 'amount_with_period_and_space_separator': matched = true; return withSeparators(2, ' ', '.');
            default: return match;
          }
        });
        if (matched) return result;
      }

      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: cartPage.dataset.currency
      }).format(cents / 100);
    }

    function updateSubtotal(cartData) {
      document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
        var number = badge.querySelector('[data-cart-count-number]');
        if (number) number.textContent = cartData.item_count;
        badge.hidden = cartData.item_count === 0;
      });
      var subtotal = cartPage.querySelector('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = formatMoney(cartData.total_price);
      var itemCountLabel = cartPage.querySelector('[data-cart-item-count-label]');
      if (itemCountLabel) {
        var template = cartData.item_count === 1 ? cartPage.dataset.itemCountOne : cartPage.dataset.itemCountOther;
        itemCountLabel.textContent = template.replace('__number__', cartData.item_count);
      }
      var checkout = cartPage.querySelector('.cart-page__checkout');
      if (checkout) checkout.textContent = cartPage.dataset.checkoutLabel + ' - ' + formatMoney(cartData.total_price);
    }

    function changeLineQuantity(key, quantity, itemEl) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (response) { return response.json(); })
        .then(function (cartData) {
          if (quantity === 0) {
            itemEl.remove();

            if (cartData.item_count === 0) {
              window.location.reload();
              return;
            }
          } else {
            var updatedLine = cartData.items.find(function (line) { return line.key === key; });
            if (updatedLine) {
              var valueEl = itemEl.querySelector('[data-quantity-value]');
              var priceEl = itemEl.querySelector('[data-item-price]');
              if (valueEl) valueEl.textContent = updatedLine.quantity;
              if (priceEl) priceEl.textContent = formatMoney(updatedLine.final_line_price);
            }
          }

          updateSubtotal(cartData);
        });
    }

    container.addEventListener('click', function (event) {
      var itemEl = event.target.closest('[data-cart-item]');
      if (!itemEl) return;

      var key = itemEl.dataset.itemKey;
      var valueEl = itemEl.querySelector('[data-quantity-value]');
      var current = parseInt(valueEl.textContent, 10) || 1;

      if (event.target.closest('[data-quantity-decrease]')) {
        var next = Math.max(1, current - 1);
        if (next !== current) changeLineQuantity(key, next, itemEl);
      } else if (event.target.closest('[data-quantity-increase]')) {
        changeLineQuantity(key, current + 1, itemEl);
      } else if (event.target.closest('[data-cart-remove]')) {
        changeLineQuantity(key, 0, itemEl);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const footerMobileQuery = window.matchMedia('(max-width: 750px)');
  const footerMenus = document.querySelectorAll('.site-footer__menu');

  const syncFooterMenus = () => {
    if (footerMobileQuery.matches) {
      footerMenus.forEach((menu) => menu.removeAttribute('open'));
    } else {
      footerMenus.forEach((menu) => menu.setAttribute('open', ''));
    }
  };

  syncFooterMenus();
  footerMobileQuery.addEventListener('change', syncFooterMenus);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('header');

  if (header) {
    const updateHeaderHeight = () => {
      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    };

    updateHeaderHeight();
    new ResizeObserver(updateHeaderHeight).observe(header);

    const applyHeroHeaderSetting = () => {
      const contentSections = [...document.querySelectorAll('.shopify-section')].filter(
        (section) => !section.closest('.shopify-section-group-header-group')
      );
      const firstContentSection = contentSections[0];
      const transparentHeader = firstContentSection?.querySelector('[data-transparent-header="true"]');

      if (transparentHeader) {
        header.classList.remove('header--default');
        header.classList.add('header--transparent');
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyHeroHeaderSetting);
    } else {
      applyHeroHeaderSetting();
    }

  }

  const drawer = document.querySelector('.header__drawer');
  const drawerClose = document.querySelector('[data-drawer-close]');

  if (drawer) {
    drawer.addEventListener('toggle', () => {
      document.documentElement.classList.toggle('no-scroll', drawer.open);
      drawer.classList.toggle('is-open', drawer.open);
    });

    drawerClose?.addEventListener('click', () => {
      drawer.open = false;
    });
  }

  const searchTrigger = document.querySelector('[data-search-trigger]');
  const searchModal = document.querySelector('[data-search-modal]');
  const searchModalClose = document.querySelector('[data-search-modal-close]');
  const desktopMediaQuery = window.matchMedia('(min-width: 1200px)');

  if (searchTrigger && searchModal) {
    const openSearchModal = () => {
      searchModal.classList.add('is-open');
      searchModal.querySelector('input[type="search"]')?.focus();
    };

    const closeSearchModal = () => {
      searchModal.classList.remove('is-open');
    };

    searchTrigger.addEventListener('click', (event) => {
      if (!desktopMediaQuery.matches) return;

      event.preventDefault();
      openSearchModal();
    });

    searchModalClose?.addEventListener('click', closeSearchModal);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeSearchModal();
    });
  }

  const megaMenuItems = document.querySelectorAll('[data-mega-menu-item]');
  const dropdownItems = document.querySelectorAll('[data-nav-dropdown-item]');
  let headerSubmenuStateTimeout;

  const scheduleHeaderSubmenuStateClose = () => {
    clearTimeout(headerSubmenuStateTimeout);
    headerSubmenuStateTimeout = setTimeout(() => {
      header?.classList.remove('header--submenu-open');
    }, 200);
  };

  dropdownItems.forEach((item) => {
    const trigger = item.querySelector('[data-nav-dropdown-trigger]');
    const isDrawerMode = !!item.closest('.header__drawer-nav-group');
    let closeTimeout;

    const openDropdown = () => {
      clearTimeout(closeTimeout);
      clearTimeout(headerSubmenuStateTimeout);
      header?.classList.add('header--submenu-open');
      dropdownItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove('is-open');
          otherItem.querySelector('[data-nav-dropdown-trigger]')?.setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.add('is-open');
      trigger?.setAttribute('aria-expanded', 'true');
    };

    const closeDropdown = () => {
      item.classList.remove('is-open');
      trigger?.setAttribute('aria-expanded', 'false');
      if (!document.querySelector('[data-nav-dropdown-item].is-open')) {
        scheduleHeaderSubmenuStateClose();
      }
    };

    if (!isDrawerMode) {
      item.addEventListener('mouseenter', openDropdown);
      item.addEventListener('mouseleave', () => {
        closeTimeout = setTimeout(closeDropdown, 150);
        scheduleHeaderSubmenuStateClose();
      });
    }

    trigger?.addEventListener('click', (event) => {
      if (!isDrawerMode) return;

      event.preventDefault();
      item.classList.contains('is-open') ? closeDropdown() : openDropdown();
    });

    trigger?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeDropdown();
      }
    });

  });

  let headerMegaStateTimeout;

  const scheduleHeaderMegaStateClose = () => {
    clearTimeout(headerMegaStateTimeout);
    headerMegaStateTimeout = setTimeout(() => {
      header?.classList.remove('header--mega-open');
    }, 200);
  };

  megaMenuItems.forEach((item) => {
    const trigger = item.querySelector('[data-mega-menu-trigger]');
    const isClickMode = !!item.closest('[data-mega-menu-click]');

    const openMegaMenu = () => {
      megaMenuItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove('is-open');
          otherItem.querySelector('[data-mega-menu-trigger]')?.setAttribute('aria-expanded', 'false');
        }
      });

      item.classList.add('is-open');
      trigger?.setAttribute('aria-expanded', 'true');
      clearTimeout(headerMegaStateTimeout);
      headerMegaStateTimeout = setTimeout(() => {
        header?.classList.add('header--mega-open');
      }, 100);
    };

    const closeMegaMenu = () => {
      clearTimeout(headerMegaStateTimeout);
      item.classList.remove('is-open');
      trigger?.setAttribute('aria-expanded', 'false');
      if (!document.querySelector('[data-mega-menu-item].is-open')) {
        scheduleHeaderMegaStateClose();
      }
    };

    let closeTimeout;

    const scheduleClose = () => {
      clearTimeout(closeTimeout);
      closeTimeout = setTimeout(closeMegaMenu, 200);
    };

    const cancelScheduledClose = () => {
      clearTimeout(closeTimeout);
    };

    if (!isClickMode) {
      item.addEventListener('mouseenter', () => {
        if (!desktopMediaQuery.matches) return;
        cancelScheduledClose();
        openMegaMenu();
      });

      item.addEventListener('mouseleave', () => {
        if (desktopMediaQuery.matches) scheduleClose();
      });
    }

    trigger?.addEventListener('click', (event) => {
      if (!isClickMode && !desktopMediaQuery.matches) return;

      event.preventDefault();
      item.classList.contains('is-open') ? closeMegaMenu() : openMegaMenu();
    });

    trigger?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMegaMenu();
    });

    item.querySelector('[data-mega-menu-back]')?.addEventListener('click', () => {
      closeMegaMenu();
    });
  });

  document.addEventListener('click', (event) => {
    dropdownItems.forEach((item) => {
      if (!item.contains(event.target)) {
        item.classList.remove('is-open');
        item.querySelector('[data-nav-dropdown-trigger]')?.setAttribute('aria-expanded', 'false');
      }
    });

    if (!document.querySelector('[data-nav-dropdown-item].is-open')) {
      scheduleHeaderSubmenuStateClose();
    }

    megaMenuItems.forEach((item) => {
      if (!item.contains(event.target)) {
        item.classList.remove('is-open');
        item.querySelector('[data-mega-menu-trigger]')?.setAttribute('aria-expanded', 'false');
      }
    });

    if (!document.querySelector('[data-mega-menu-item].is-open')) {
      scheduleHeaderMegaStateClose();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-modal"] && !Shopify.designMode) return;
  try {
    
  if (!window.newsletterModalHandlersBound) {
    window.newsletterModalHandlersBound = true;

    document.addEventListener('click', (event) => {
      const bannerLink = event.target.closest('.top-bar__text--left a');
      if (bannerLink) {
        const modal = document.querySelector('[data-newsletter-modal]');
        if (!modal) return;

        event.preventDefault();
        if (!modal.open) modal.showModal();
        return;
      }

      const closeButton = event.target.closest('[data-newsletter-modal-close]');
      if (closeButton) {
        closeButton.closest('[data-newsletter-modal]')?.close();
      }
    });

    document.addEventListener('click', (event) => {
      const modal = event.target;
      if (!modal.matches?.('[data-newsletter-modal]')) return;

      const bounds = modal.getBoundingClientRect();
      const insideDialog = event.clientX >= bounds.left && event.clientX <= bounds.right
        && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
      if (!insideDialog) modal.close();
    });

    const newsletterModal = document.querySelector('[data-newsletter-modal]');
    const params = new URLSearchParams(window.location.search);
    const signupSucceeded = params.get('customer_posted') === 'true';
    const signupHasErrors = newsletterModal?.querySelector('.site-footer__message--error');

    if (newsletterModal && (signupSucceeded || signupHasErrors) && !newsletterModal.open) {
      newsletterModal.showModal();
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-feature"] && !Shopify.designMode) return;
  try {
    
  const parallaxFeatures = document.querySelectorAll('.parallax-feature');

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const updateParallax = () => {
      parallaxFeatures.forEach((feature) => {
        const bounds = feature.getBoundingClientRect();
        const progress = (window.innerHeight - bounds.top) / (window.innerHeight + bounds.height);
        feature.style.setProperty('--parallax-progress', Math.max(0, Math.min(1, progress)));
      });
    };

    updateParallax();
    window.addEventListener('scroll', updateParallax, { passive: true });
    window.addEventListener('resize', updateParallax);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  const topBar = document.querySelector('.top-bar');

  if (topBar) {
    const slides = topBar.querySelectorAll('[data-top-bar-slide]');
    let activeSlide = 0;

    if (slides.length > 1) {
      window.setInterval(() => {
        slides[activeSlide].classList.remove('is-active');
        activeSlide = (activeSlide + 1) % slides.length;
        slides[activeSlide].classList.add('is-active');
      }, 4000);
    }

    const updateTopBarHeight = () => {
      document.documentElement.style.setProperty('--top-bar-height', `${topBar.offsetHeight}px`);
    };

    updateTopBarHeight();
    new ResizeObserver(updateTopBarHeight).observe(topBar);
  }


  } catch(e) { console.error(e); }
})();
})();
